export default {
	title: 'シナリオ',
	subtitle: '評価する可能性のあるシナリオを一覧します',
	no_description: 'シナリオなし',

	context_worse: 'ネガティブ',
	context_best: 'ポジティブ',

	tabs: {
		list: '一覧',
		details: '詳細',
		visualization: 'ビジュアル',
		alt_title: '総合'
	}
};
